import { ButtonUtils, ObjectBuilder, GridUtils, Image3D, RichTextGrammar } from "@dreamcam/babylon-tools";
import { Container } from "@babylonjs/gui/2D/controls/container.js";
import { Env } from "../../settings/Env";
import { LayoutComponentHelper } from "./LayoutComponentHelper";
/**
 * ChatList item.
  */
export class MessengerChatListLayoutHelper {
    static createChatView(params) {
        const id = params.chatId ?? "Pinned";
        const it = Env.common.messengerChatListPanel.item;
        const mesh2d = params.mesh2d;
        const button = ButtonUtils.CreateImgButton(`chatListItem${id}`, it.buttonLayout, mesh2d);
        button.widthInPixels = mesh2d.m2px(it.width);
        button.heightInPixels = mesh2d.m2px(it.height);
        const avatarControls = LayoutComponentHelper.createModelProfileControl(mesh2d, button, it.avatar);
        avatarControls.rootContainer.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_LEFT;
        avatarControls.rootContainer.widthInPixels = avatarControls.outlineContainer.widthInPixels;
        avatarControls.rootContainer.leftInPixels = mesh2d.m2px(it.avatar.left);
        avatarControls.rootContainer.isVisible = false;
        button.addControl(avatarControls.rootContainer);
        const unavailableAvatar = new Image3D(`messengerChatUnavailableAvatar${id}`, it.unavailableAvatar.src);
        unavailableAvatar.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_LEFT;
        unavailableAvatar.widthInPixels = mesh2d.m2px(it.unavailableAvatar.width);
        unavailableAvatar.heightInPixels = mesh2d.m2px(it.unavailableAvatar.height);
        unavailableAvatar.left = mesh2d.m2px(it.unavailableAvatar.left);
        unavailableAvatar.isVisible = false;
        button.addControl(unavailableAvatar);
        const unavailableAvatarLetter = ObjectBuilder.createTextBlock3D(mesh2d, "messengerChatUnavailableAvatarLetter", "", it.unavailableAvatar.letter);
        unavailableAvatarLetter.zIndex = 1;
        unavailableAvatarLetter.isVisible = false;
        button.addControl(unavailableAvatarLetter);
        const topLineGrid = GridUtils.CreateGrid(`messengerChatTopLineGrid${id}`, it.topLine.grid, mesh2d);
        topLineGrid.horizontalAlignment = Container.HORIZONTAL_ALIGNMENT_LEFT;
        topLineGrid.verticalAlignment = Container.VERTICAL_ALIGNMENT_TOP;
        topLineGrid.leftInPixels = mesh2d.m2px(it.topLine.left);
        topLineGrid.topInPixels = mesh2d.m2px(it.topLine.top);
        topLineGrid.widthInPixels = mesh2d.m2px(it.topLine.width);
        topLineGrid.heightInPixels = mesh2d.m2px(it.topLine.height);
        button.addControl(topLineGrid);
        const favoriteStarImage = new Image3D(`messengerChatFavoritesStar${id}`, it.topLine.star.src);
        favoriteStarImage.widthInPixels = mesh2d.m2px(it.topLine.star.width);
        favoriteStarImage.heightInPixels = mesh2d.m2px(it.topLine.star.height);
        favoriteStarImage.paddingRightInPixels = mesh2d.m2px(it.topLine.star.paddingRight);
        favoriteStarImage.isVisible = false;
        topLineGrid.addControl(favoriteStarImage, 0, 0);
        const modelNicknameTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, `messengerChatModelNickname${id}`, "", it.topLine.modelNickname);
        topLineGrid.addControl(modelNicknameTextBlock, 0, 1);
        const addStatusIcon = (name, src) => {
            const result = new Image3D(name, src);
            result.widthInPixels = mesh2d.m2px(it.topLine.statusIcon.width);
            result.heightInPixels = mesh2d.m2px(it.topLine.statusIcon.height);
            result.paddingRightInPixels = mesh2d.m2px(it.topLine.statusIcon.paddingRight);
            result.isVisible = false;
            return result;
        };
        const sentIcon = addStatusIcon(`messengerChatSentIcon${id}`, it.topLine.statusIcon.imgSent);
        topLineGrid.addControl(sentIcon, 0, 2);
        const readIcon = addStatusIcon(`messengerChatReadIcon${id}`, it.topLine.statusIcon.imgRead);
        topLineGrid.addControl(readIcon, 0, 2);
        const unreadNotificationIcon = addStatusIcon(`messengerChatUnreadNotificationIcon${id}`, it.topLine.statusIcon.imgUnread);
        topLineGrid.addControl(unreadNotificationIcon, 0, 2);
        const lastMessageTimeTextBlock = ObjectBuilder.createTextBlock3D(mesh2d, `messengerChatLastMessageTime${id}`, "", it.topLine.time);
        topLineGrid.addControl(lastMessageTimeTextBlock, 0, 3);
        const statusTextBlock = ObjectBuilder.createRichTextBlock3D(`messengerPanelHeaderStatus${id}`, "", it.status.text, RichTextGrammar.RTTag, mesh2d);
        button.addControl(statusTextBlock);
        return {
            rootContainer: button,
            modelButton: button,
            avatar: {
                rootContainer: avatarControls.rootContainer,
                modelProfileImage: avatarControls.modelProfileImage,
                outlineContainer: avatarControls.outlineContainer,
                statusTextContainer: avatarControls.statusTextContainer,
                statusText: avatarControls.statusText,
            },
            unavailableAvatar,
            unavailableAvatarLetter,
            favoriteStarImage,
            modelNicknameTextBlock,
            sentIcon,
            readIcon,
            unreadNotificationIcon,
            lastMessageTimeTextBlock,
            statusTextBlock,
        };
    }
}
